import styled from 'styled-components';

import { DeviceTypeContent } from 'containers/Devices/components/DeviceTypeCell/styles';

export const DeviceLabel = styled(DeviceTypeContent)`
  flex: 1;
`;

export const Container = styled.div<{ text?: boolean }>`
  display: flex;
  flex-direction: row;
  margin-top: -4px;
  color: ${({ theme }) => theme.palette.primary.dark};
  font: 14px/16px Roboto;
  align-items: center;
`;

export const DevicesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  & > * {
    margin-top: 4px;
  }
  margin-left: 18px;
`;

export const InsufficientLicensesBanner = styled('p')`
  background: ${({ theme }) => theme.palette.error.light};
  border-radius: 4px;
  font: normal normal medium 14px/16px Roboto;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.palette.primary.dark};
  padding: 8px 12px;
  width: 100%;
`;

export const LicenseManagementLink = styled('a')`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-weight: bold;
  text-decoration: underline;
  margin-left: 4px;
`;

export const AdditionalDevicesChipContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;
